(() => {
  let mountFrame = 0;

  const mount = (scope = document) => {
    scope.querySelectorAll('.natural-pdp').forEach((section) => {
      const stickyCart = section.querySelector('.sticky_cart');
      if (!stickyCart || stickyCart.dataset.naturalPdpPortal === 'true') return;

      const host = document.createElement('div');
      // The host is only a body-level positioning stage. Giving it the
      // section's `natural-pdp` class also applies the PDP white surface to a
      // full-viewport fixed element on mobile, visually covering the real PDP.
      host.className = 'natural-pdp-sticky-portal-host';
      host.dataset.naturalPdpStickyHost = section.id || section.dataset.section || 'product';
      stickyCart.dataset.naturalPdpPortal = 'true';
      stickyCart.classList.add('natural-pdp-sticky-portal');
      document.body.appendChild(host);
      host.appendChild(stickyCart);
    });
  };

  const scheduleMount = (scope = document) => {
    if (mountFrame) window.cancelAnimationFrame(mountFrame);
    mountFrame = window.requestAnimationFrame(() => {
      mountFrame = window.requestAnimationFrame(() => {
        mountFrame = 0;
        mount(scope);
      });
    });
  };

  const start = () => scheduleMount(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => scheduleMount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector?.('.natural-pdp') || event.target;
    const sectionId = section?.id || section?.dataset?.section;
    document.querySelectorAll('.natural-pdp-sticky-portal-host').forEach((host) => {
      if (!sectionId || host.dataset.naturalPdpStickyHost === sectionId) host.remove();
    });
  });
})();
